import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GraphicEqIcon(props: IconProps) {
    return <Icon {...props} iconKey={"graphic_eq"}/>
}
